import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

function Sidebar({ isOpen, onClose }) {
  const user = JSON.parse(localStorage.getItem('user'));
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const handleNavLinkClick = () => {
    if (isOpen) {
      onClose();
    }
  };

  const navLinkClass = ({ isActive }) =>
    `flex items-center space-x-4 px-6 py-3 transition-all duration-200 relative ${isActive
      ? "text-slate-900 font-bold bg-white"
      : "text-slate-500 font-medium hover:text-slate-900 hover:bg-slate-100"
    }`;

  const ActiveIndicator = () => (
     <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#4f46e5] rounded-r-md"></div>
  );

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && (
        <div className="fixed inset-0 bg-slate-900/50 z-40 md:hidden" onClick={onClose} />
      )}

      <aside className={`fixed left-0 top-0 h-screen w-64 z-50 bg-[#f8f9fa] flex flex-col font-inter text-sm transition-transform duration-300 md:translate-x-0 border-r border-slate-200 ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <div className="flex items-center justify-between px-8 py-8 mb-4">
          <div className="flex items-center space-x-2 text-slate-900">
             <span className="material-symbols-outlined text-2xl font-bold">account_balance_wallet</span>
             <span className="text-xl font-bold font-manrope tracking-tight">FinControl</span>
          </div>
          <button className="md:hidden text-slate-500 hover:text-slate-800" onClick={onClose}>
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>

        <nav className="flex-1 space-y-1 overflow-y-auto no-scrollbar">
          <NavLink to="/app/dashboard" className={navLinkClass} onClick={handleNavLinkClick}>
            {({ isActive }) => (
              <>
                {isActive && <ActiveIndicator />}
                <span className="material-symbols-outlined text-[20px]">grid_view</span>
                <span>Dashboard</span>
              </>
            )}
          </NavLink>

          <NavLink to="/app/transactions" className={navLinkClass} onClick={handleNavLinkClick}>
            {({ isActive }) => (
              <>
                {isActive && <ActiveIndicator />}
                <span className="material-symbols-outlined text-[20px]">sync_alt</span>
                <span>Transações</span>
              </>
            )}
          </NavLink>

          <NavLink to="/app/budgets" className={navLinkClass} onClick={handleNavLinkClick}>
            {({ isActive }) => (
              <>
                {isActive && <ActiveIndicator />}
                <span className="material-symbols-outlined text-[20px]">pie_chart</span>
                <span>Orçamentos</span>
              </>
            )}
          </NavLink>

          <NavLink to={user?.subscription_status === 'ACTIVE' ? "/app/credit-cards" : "/app/subscription"} className={navLinkClass} onClick={handleNavLinkClick}>
            {({ isActive }) => (
              <>
                {isActive && <ActiveIndicator />}
                <span className="material-symbols-outlined text-[20px]">credit_card</span>
                <div className="flex w-full justify-between items-center">
                  <span>Cartões</span>
                  {user?.subscription_status !== 'ACTIVE' && <span className="material-symbols-outlined text-sm text-yellow-500">lock</span>}
                </div>
              </>
            )}
          </NavLink>

          <NavLink to={user?.subscription_status === 'ACTIVE' ? "/app/income-tax" : "/app/subscription"} className={navLinkClass} onClick={handleNavLinkClick}>
            {({ isActive }) => (
              <>
                {isActive && <ActiveIndicator />}
                <span className="material-symbols-outlined text-[20px]">description</span>
                <div className="flex w-full justify-between items-center">
                  <span>Imposto de Renda</span>
                  {user?.subscription_status !== 'ACTIVE' && <span className="material-symbols-outlined text-sm text-yellow-500">lock</span>}
                </div>
              </>
            )}
          </NavLink>

          <NavLink to="/app/reports" className={navLinkClass} onClick={handleNavLinkClick}>
            {({ isActive }) => (
              <>
                {isActive && <ActiveIndicator />}
                <span className="material-symbols-outlined text-[20px]">bar_chart</span>
                <span>Relatórios</span>
              </>
            )}
          </NavLink>
        </nav>

        <div className="px-6 pb-6 pt-4 space-y-2 mt-auto">
          {user?.subscription_status !== 'ACTIVE' ? (
            <NavLink to="/app/subscription" className="w-full bg-[#4f46e5] text-white py-3 px-4 rounded-lg font-bold shadow-md shadow-indigo-600/20 flex items-center justify-center space-x-2 hover:-translate-y-0.5 transition-all" onClick={handleNavLinkClick}>
              <span>Seja Premium</span>
            </NavLink>
          ) : (
            <button
              onClick={() => {
                handleNavLinkClick();
                navigate('/app/transactions', { state: { openAddIncome: true } });
              }}
              className="w-full bg-[#4f46e5] text-white py-3 px-4 rounded-lg font-bold shadow-md shadow-indigo-600/20 flex items-center justify-center space-x-2 hover:-translate-y-0.5 transition-all">
              <span className="material-symbols-outlined text-[18px]">add</span>
              <span>Nova Receita</span>
            </button>
          )}

          <NavLink to="/app/settings" className="flex items-center space-x-3 px-4 py-3 text-slate-500 hover:bg-slate-100 rounded-lg transition-all text-sm font-medium" onClick={handleNavLinkClick}>
            <span className="material-symbols-outlined text-[20px]">settings</span>
            <span>Configurações</span>
          </NavLink>

          <button onClick={handleLogout} className="w-full flex items-center space-x-3 px-4 py-3 text-slate-400 hover:bg-red-50 hover:text-red-500 rounded-lg transition-all text-sm font-medium text-left mt-4 border-t border-slate-200">
            <span className="material-symbols-outlined text-[20px]">logout</span>
            <span>Sair do Sistema</span>
          </button>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;